import { combineAllWatchers } from '@sonar-software/xuder';
import { combineReducers } from 'redux';
import { securityAuthenticationEnrollPostAsyncSlice } from './post';

export const securityAuthenticationEnrollReducers = combineReducers({
	post: securityAuthenticationEnrollPostAsyncSlice.asyncReducers
});

export const securityAuthenticationEnrollWatchers = combineAllWatchers([
	securityAuthenticationEnrollPostAsyncSlice.asyncWatchers
]);
